import React from 'react';
import CalendarPanel from './CalendarPanel';
import IndividualBookingForm from './IndividualBookingForm';

const Scheduling = ({
  config,
  formData,
  onSubmit,
  isLoading,
  error,
  success,
  schedulingResult,
  selectedDate,
  onDateChange,
  dateRange,
  onEditBooking,
  loading,
  refreshTrigger
}) => {

  return (
    <div className="flex h-full w-full flex-1 overflow-hidden">
      {/* Left Panel - Scheduling Form */}
      <div className="w-[30%] min-w-[350px] max-w-[450px] flex-shrink-0 bg-white shadow-lg m-4 rounded-lg overflow-auto">
        <div className="p-4">
          {/* Title */}
          <div className="pb-2">
            <h2 className="text-xl font-bold">Individual Schedule</h2>
          </div>

          {/* Form Content */}
          <div className="pt-2">
            <IndividualBookingForm
              initialFormData={formData}
              onSubmit={onSubmit}
              config={config}
              isLoading={isLoading}
              schedulingResult={schedulingResult}
              error={error}
              success={success}
              isVisible={true}
            />
          </div>
        </div>
      </div>

      {/* Right Panel - Calendar */}
      <div className="flex-1 min-w-0 overflow-hidden">
        <div className="w-full h-full overflow-auto">
          <CalendarPanel
            selectedDate={selectedDate}
            onDateChange={onDateChange}
            dateRange={dateRange}
            config={config}
            onEditBooking={onEditBooking}
            isLoading={loading}
            refreshTrigger={refreshTrigger}
          />
        </div>
      </div>
    </div>
  );
};

export default Scheduling;

